<template>
    <div :class="'Wrapper-'+pageType" class="Wrapper" id="Wrapper">
        <WebsiteStatistics v-if="dataLoaded" />
        <WebsiteMeta v-if="dataLoaded" />
        <debugArticleSwitch v-if="debug" />
        <WebsiteHeader v-if="dataLoaded" />
        <router-view :key="$route.fullPath" v-if="dataLoaded" />
        <ArticleNavigation v-if="pageType === 'article'" />
        <WebsiteFooter v-if="dataLoaded" />
        <LoadingSpinner v-if="!dataLoaded" />
        <Tracking />
        <StylesUpdater />
    </div>
</template>

<script>
    import router from '@/router';
    import store from '@/store';

    router.beforeEach((to, from, next) => {
        let cleanedQuery = Object.assign({}, to.query);

        // Clean up the URL from hidden request
        if (cleanedQuery.hidden !== undefined) {
            store.dispatch('setHidden');
            delete cleanedQuery.hidden;
            next();
        }

        // Clean up the URL from sharing referal
        if (cleanedQuery.sharedOn !== undefined) {
            store.dispatch('setSharedOn', cleanedQuery.sharedOn);
            delete cleanedQuery.sharedOn;
        }
        next();
    });
    export default {
        name: 'App',
        components: {
            'WebsiteStatistics': () => import('@/components/WebsiteStatistics'),
            'WebsiteMeta': () => import('@/components/WebsiteMeta'),
            'debugArticleSwitch': () => import('@/components/debugArticleSwitch'),
            'WebsiteHeader': () => import('@/components/WebsiteHeader'),
            'WebsiteFooter': () => import('@/components/WebsiteFooter'),
            'ArticleNavigation': () => import('@/components/ArticleNavigation'),
            'LoadingSpinner': () => import('@/components/LoadingSpinner'),
            'Tracking': () => import('@/components/Tracking'),
            'StylesUpdater': () => import('@/components/StylesUpdater')
        },
        async mounted() {
            await store.dispatch('getWebsiteSettings').catch(error => error);
        },
        computed: {
            dataLoaded() {
                return store.state.loaded;
            },
            debug() {
                return true;//process.env.NODE_ENV === 'development';
            },
            relmKey() {
                return store.state.relmKey;
            },
            consumer() {
                return store.state.consumer;
            },
            pageType() {
                return store.state.currentPageType;
            }
        },
        watch: {
            '$route': function () {
                this.$store.dispatch('loadingFeedback', true);
                this.scriptElementExecution();
            },
            '$route.params.relmKey': function () {
                // Set the relm Key
                this.setCurrentRelmKey(this.$route.params.relmKey);
                this.checkDoNotTrackFromBrowser();
            },
            '$route.params.persona': function () {
                this.setCurrentPersona({
                    'persona': this.$route.params.persona,
                    'step': this.$route.params.step
                });
            },
            consumer: function () {
                if (this.consumer !== null) {
                    router.replace({ params: { relmKey: this.consumer.sharedKey } }).catch(() => {});
                }
                if (this.consumer.sharedKey === '' || this.consumer.sharedKey === undefined) {
                    router.replace({ name: 'anonymous' }).catch(() => {});
                }
            }
        },
        methods: {
            scriptElementExecution() {
                const scriptList = document.getElementsByClassName('trackingScript');
                for (let i = 0; i < scriptList.length; i++) {
                    eval(scriptList[i].textContent);
                }
            },
            setCurrentRelmKey(relmKey) {
                if (this.relmKey === null) {
                    // Check if there is a previous record
                    if (this.consumer !== null) {
                        switch (relmKey) {
                            // Check if the current record is the relm key or the shared key
                            case this.consumer.relmKey:
                            case this.consumer.sharedKey:
                                relmKey = this.consumer.relmKey;
                                break;
                        }
                    }
                    // Remove current record and go to the wished one
                    this.$store.dispatch('setCurrentRelmKey', relmKey);
                }
            },
            async setCurrentPersona(persona) {
                this.$store.dispatch('getPersonaSettings', persona).then(() => {
                    router.replace({ params: { relmKey: this.consumer.relmKey } }).catch(() => {});
                });
            },
            checkDoNotTrackFromBrowser() {
                const doNotTrackOption = (window.doNotTrack || window.navigator.doNotTrack || window.navigator.msDoNotTrack);
                if (doNotTrackOption !== undefined && doNotTrackOption.charAt(0) === '1' || doNotTrackOption === 'yes') {
                    this.$store.dispatch('setDoNotTrack', true);
                } else {
                    this.$store.dispatch('setDoNotTrack', false);
                }
            }
        }
    };
</script>

<style lang="scss">
    @import "scss/App";
</style>
